module.exports = __webpack_public_path__ + "img/register-v2.e470a9d9.svg";